import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'skeleton-app-flat-hierarchy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-flat-hierarchy.component.html',
})
export class UISkeletonFlatHierarchyComponent {
  @Input() contentWidth: string = new Input('');
}
